import SweetScroll from 'sweet-scroll';

export default class AnimateScroll {
    constructor() {
        this.init();
    }

    init() {
        const scroller = new SweetScroll({
            /* some options */
        });
    }
}